import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { defaultDateFormat } from '@/constants/formats'

export default function (value) {
  if (!value) return ''
  if (typeof value === 'string') {
    return format(new Date(value), defaultDateFormat, { locale: es })
  } else if (value instanceof Date) {
    return format(value, defaultDateFormat)
  }
  return 'Invalid Date Format'
}
